import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button, FormControl } from "@/comn/components"; // 화면 구성 컴포넌트
import { useFetch, useForm, useGrid, useStore, useToast, useResource, useModal, usePage, usePopup } from "@/comn/hooks";
import { BASE, URLS, APIS, SF_LCNE_USR_INFO } from "@/tra/tancis/ptli/usr/lcneusr/services/PtliLcneUsrService";
import { LCNE_USE_TP_CD_UTIL } from "@/tra/tancis/ptli/usr/lcneusr/services/PtliLcneUsrService";

/*
 * License User Registration
 * !== 면허 사용자 등록 ==!
 */
export const PTLI0906002S = (): JSX.Element => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_lcmi0001", "auth_ptli0025", "auth_eswi0001", "auth_ptlianyADM"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { openPopup } = usePopup();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast();
    const isInited = useRef(false);

    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { getResource } = useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "LCM0001" }, { area: "cstmCd" }],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // License User Information !== 면허 사용자 정보 ==!
        lcneUsrInfo: useForm({
            defaultSchema: SF_LCNE_USR_INFO,
            defaultValues: { cstmOfceCd: "TZDL" },
        }),
    };

    const coTin = form.lcneUsrInfo.watch("coTin");
    const ectYn = form.lcneUsrInfo.watch("ectYn", "N");
    const initialSchema = useRef(form.lcneUsrInfo.schema.lcneTpCd);

    const [coTinMdfyChk, setCoTinMdfyChk] = useState(false);
    const [coTinCntyChk, setCoTinCntyChk] = useState(false);

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Create License User !== 면허 사용자 등록 ==!
        createLcneUsr: useFetch({
            api: (data) => APIS.createLcneUsr({ ...data }),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.com.00062", // Successfully saved., !== 정상적으로 저장되었습니다. ==!
                    onConfirm: () => {
                        navigate(URLS.ptli0906001q);
                    },
                    onCancel: () => {
                        navigate(URLS.ptli0906001q);
                    },
                });
            },
            onError: (error) => {
                console.log(error);
                if (error.response.status === 400) {
                    console.log(error.response.data);
                    form.lcneUsrInfo.setErrors(error.response.data.errors);
                }

                modal.openModal({
                    content: "msg.00006",
                });
            },
        }),
        getTinNoLst: useFetch({
            api: () => {
                // let bizYn = "Y";
                // const lcneTpArr = form.lcneUsrInfo.getValue("lcneTpCd");
                // if (!comnUtils.isUndefined(lcneTpArr)) {
                //     if (lcneTpArr.length == 1) {
                //         if (lcneTpArr[0] == "5") {
                //             bizYn = "";
                //         }
                //     }
                // }
                // return APIS.getPayerTinNoLst(coTin, bizYn);
                return APIS.getPayerTinNoLst(coTin, "");
            },
            // enabled: !!coTin,
            // key: [coTin],
            onSuccess: (data) => {
                const tinNoList = data.tinNoList.content;

                if (tinNoList.length == 1) {
                    const tinNoInfo = tinNoList[0];
                    form.lcneUsrInfo.setValue("coTin", tinNoInfo.tinNo);
                    form.lcneUsrInfo.setValue("coNm", tinNoInfo.coNm);
                    form.lcneUsrInfo.setValue("rprsTelno", tinNoInfo.rprsTelno);
                    form.lcneUsrInfo.setValue("rprsFaxNo", tinNoInfo.rprsFaxNo);
                    form.lcneUsrInfo.setValue("rprsEml", tinNoInfo.rprsEml);
                    form.lcneUsrInfo.setValue("coAddr", tinNoInfo.coAddr);
                    form.lcneUsrInfo.setValue("bizTpCd", tinNoInfo.bizTpCd);
                    form.lcneUsrInfo.setValue("tinTp", tinNoInfo.tinTp);

                    setCoTinMdfyChk(false);

                    if (tinNoInfo.bizTpCd === "007") {
                        if (coTinCntyChk) {
                            // true => TZA가 아님
                            form.lcneUsrInfo.setSchema("lcneTpCd", {
                                ...form.lcneUsrInfo.schema.lcneTpCd,
                                // COT, C40, C28 + ORA CFA만 남기고 제외
                                excludes: ["0", "1", "2", "3", "4", "8", "9", "10", "11", "12", "13", "14"],
                            });
                        } else {
                            // false => TZA임
                            form.lcneUsrInfo.setSchema("lcneTpCd", {
                                ...form.lcneUsrInfo.schema.lcneTpCd,
                                // COT, C40, C28만
                                excludes: ["0", "1", "2", "3", "4", "8", "9", "10", "11", "12", "13", "14", "15"],
                            });
                        }
                    } else {
                        // 초기 상황(excludes 하기 전) 으로 돌리기
                        form.lcneUsrInfo.setSchema("lcneTpCd", initialSchema.current);
                    }
                } else {
                    toast.showToast({ type: "error", content: "msg.clr.00004" });
                }
            },
        }),

        // License Company Tin apply check !== 면허 업체 TIN 신청 여부 체크 ==!
        getAplyDuplCheck: useFetch({
            api: (data: any) => APIS.getAplyDuplCheck(data),
            enabled: false,
            onSuccess: (data) => {
                if (!data.aplyDuplCheck.content) {
                    form.lcneUsrInfo.clearErrors("coTin");
                    fetch.getUsrDuplCheck.fetch(coTin); // 등록여부 체크
                    fetch.getCoTinCntyCheck.fetch(coTin); // 국가 체크
                } else {
                    form.lcneUsrInfo.setError("coTin", {
                        message: "msg.ptl.00795", // This company is already applying. !== 이미 신청중인 업체입니다. ==!
                        type: "error",
                    });

                    form.lcneUsrInfo.setValue("coNm", null);
                    form.lcneUsrInfo.setValue("rprsTelno", null);
                    form.lcneUsrInfo.setValue("rprsFaxNo", null);
                    form.lcneUsrInfo.setValue("rprsEml", null);
                    form.lcneUsrInfo.setValue("coAddr", null);
                }
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),

        // Tin duplicate check  !== TIN 중복 체크 ==!
        getUsrDuplCheck: useFetch({
            api: (data: any) => APIS.getUsrDuplCheck(data),
            enabled: false,
            onSuccess: (data) => {
                if (!data.usrDuplCheck.content) {
                    form.lcneUsrInfo.clearErrors("coTin");
                    fetch.getTinNoLst.fetch();
                } else {
                    form.lcneUsrInfo.setError("coTin", {
                        message: "msg.ptl.00752", // This company is already registered. !== 이미 등록된 업체 입니다. ==!
                        type: "error",
                    });

                    form.lcneUsrInfo.setValue("coNm", null);
                    form.lcneUsrInfo.setValue("rprsTelno", null);
                    form.lcneUsrInfo.setValue("rprsFaxNo", null);
                    form.lcneUsrInfo.setValue("rprsEml", null);
                    form.lcneUsrInfo.setValue("coAddr", null);
                }
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
        getCoTinCntyCheck: useFetch({
            api: (data: any) => APIS.getCoTinCntyCheck(data),
            enabled: false,
            onSuccess: (data) => {
                if (data.coTinCntyCheck.content) {
                    // TZA가 아니면 1을 출력하고, TZA 이면 0을 출력함
                    setCoTinCntyChk(true);
                } else {
                    // TZA 일 때,
                    setCoTinCntyChk(false);
                }
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        checkPwd: () => {
            const coPwd = form.lcneUsrInfo.getValue("coPwd");
            const coPwdCfrm = form.lcneUsrInfo.getValue("coPwdCfrm");

            if (!comnUtils.isEmpty(coPwd) && !comnUtils.equals(coPwd, coPwdCfrm)) {
                form.lcneUsrInfo.setError("coPwdCfrm", {
                    message: "msg.ptl.00712", // Passwords do not match. !== 비밀번호가 일치하지 않습니다. ==!
                    type: "error",
                });
            } else {
                form.lcneUsrInfo.clearErrors("coPwdCfrm");
            }
        },
        // Create License User !== 면허 사용자 등록 ==!
        createLcneUsr: () => {
            if (!comnUtils.isEmpty(form.lcneUsrInfo.errors)) {
                toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            form.lcneUsrInfo.handleSubmit(
                () => {
                    const data = form.lcneUsrInfo.getValues();
                    const lcneTpCdArr = form.lcneUsrInfo.getValue("lcneTpCd");
                    const bizTpCd = form.lcneUsrInfo.getValue("bizTpCd");
                    // const checkOnlyCOT = lcneTpCdArr?.includes("5") && lcneTpCdArr?.length === 1;

                    // data.lcneTpCdArray = LCNE_USE_TP_CD_UTIL.makeLcneUseTpCdDtoArray(form.lcneUsrInfo, "BASE");
                    const checkCOT = lcneTpCdArr?.includes("5");
                    const checkC40 = lcneTpCdArr?.includes("6");
                    const checkC28 = lcneTpCdArr?.includes("7");

                    if (bizTpCd === "007") {
                        const codesWithoutCFA = lcneTpCdArr?.filter((code: string) => code !== "15");
                        const onlyAllowed = codesWithoutCFA.every((code: string) => ["5", "6", "7"].includes(code));

                        // COT 필수 + C40 또는 C28 중 하나 이상 포함 / 나머지 case는 전부 toast 처리
                        if (!checkCOT || (!checkC40 && !checkC28) || !onlyAllowed) {
                            toast.showToast({ type: "warning", content: "msg.ptl.00823" });
                            return;
                        }
                    }

                    if (coTinMdfyChk) {
                        // coTinMdfyChk 가 true 인 경우 >> 변경 됨 확인
                        toast.showToast({ type: "warning", content: "msg.ptl.00755" }); // Please check your TIN. !== TIN을 조회해주세요. ==!
                        return;
                    } else {
                        modal.openModal({
                            content: "msg.00101", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                            onConfirm: () => {
                                fetch.createLcneUsr.fetch(data);
                            },
                            close: false,
                        });
                    }
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                },
            )();
        },
    };

    useEffect(() => {
        form.lcneUsrInfo.setFocus("coTin");
        const lcneTpComnCdList = getResource("comnCd", "LCM0001");
        const lcneTpCdArr = LCNE_USE_TP_CD_UTIL.initLcneUseTpCdSchema({
            form: form.lcneUsrInfo,
            lcneTpComnCdList: lcneTpComnCdList,
            isEditeable: true,
            t: t,
        });
    }, []);

    const lcneTpCd = form.lcneUsrInfo.watch("lcneTpCd");

    useEffect(() => {
        const lcneTpComnCdList = getResource("comnCd", "LCM0001");
        if (!isInited.current && lcneTpComnCdList?.length > 0) {
            isInited.current = true;
            const lcneTpCdArr = LCNE_USE_TP_CD_UTIL.initLcneUseTpCdSchema({
                form: form.lcneUsrInfo,
                lcneTpComnCdList: lcneTpComnCdList,
                isEditeable: true,
                t: t,
            });
        }
    }, [lcneTpCd]);

    useEffect(() => {
        setCoTinMdfyChk(true);
    }, [coTin]);

    return (
        <Page>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control
                                    {...form.lcneUsrInfo.schema.coTin}
                                    rightButton={{
                                        icon: "search",
                                        onClick: () => {
                                            const usrNo = form.lcneUsrInfo.getValue("coTin");
                                            if (usrNo?.length == 9) {
                                                form.lcneUsrInfo.clearErrors("coTin");
                                                fetch.getAplyDuplCheck.fetch(usrNo);
                                            } else {
                                                form.lcneUsrInfo.setError("coTin", {
                                                    message: "msg.esw.00070", // TIN must be 9 digits. !== TIN은 9자리여야 합니다. ==!
                                                    type: "error",
                                                });
                                            }
                                        },
                                    }}
                                    maxLength={9}
                                />
                                <Group.Control {...form.lcneUsrInfo.schema.coNm}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.lcneUsrInfo.schema.cstmOfceCd} disabled={true}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.lcneUsrInfo.schema.rprsTelno}></Group.Control>
                                <Group.Control {...form.lcneUsrInfo.schema.rprsFaxNo}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.lcneUsrInfo.schema.rprsEml}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.lcneUsrInfo.schema.coAddr}></Group.Control>
                            </Group.Row>
                            {/* <Group.Row>
                                <Group.Control {...form.lcneUsrInfo.schema.coPwd}></Group.Control>
                                <Group.Control
                                    {...form.lcneUsrInfo.schema.coPwdCfrm}
                                    onBlur={() => {
                                        handler.checkPwd();
                                    }}
                                />
                            </Group.Row> */}
                            <Group.Row>
                                <Group.Control {...form.lcneUsrInfo.schema.ectYn}></Group.Control>
                            </Group.Row>
                            {ectYn != "Y" && (
                                <Group.Row>
                                    <Group.Control {...form.lcneUsrInfo.schema.lcneTpCd}></Group.Control>
                                </Group.Row>
                            )}
                            {ectYn !== "Y" &&
                                LCNE_USE_TP_CD_UTIL.isLcneUseTpCdTarget({
                                    lcneTpCd: "1",
                                    lcneTpCdChekedArr: form.lcneUsrInfo.getValue("lcneTpCd"),
                                }) && (
                                    <Group.Row>
                                        <Group.Control
                                            {...form.lcneUsrInfo.schema[LCNE_USE_TP_CD_UTIL.getLcneUseTpCdVarNm("1")]}
                                            required={true}
                                        ></Group.Control>
                                    </Group.Row>
                                )}
                        </Group.Section>
                    </Group.Body>
                </Group>
            </form>
            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.ptli0906001q);
                        }}
                    ></Button>
                </Layout.Left>
                <Layout.Right>
                    <Button
                        role="save"
                        onClick={() => {
                            handler.createLcneUsr();
                        }}
                    ></Button>
                </Layout.Right>
            </Layout>
        </Page>
    );
};
